if($('.type-detail').length){
    $(document).ready(function() {
        var name = $('.p-detail meta[itemprop="name"]').attr('content')
        var url = $('#product-detail-form meta[itemprop="url"]').attr('content')
        var image = $('.p-detail meta[itemprop="image"]').attr('content')
        var description = $('.p-detail meta[itemprop="description"]').attr('content').trim()
        var sku = $('#product-detail-form meta[itemprop="sku"]').attr('content')
        var brand = $('.p-detail span[itemprop="brand"] meta[itemprop="name"]').attr('content')
        var priceCurrency = $('#product-detail-form meta[itemprop="priceCurrency"]').attr('content')
        var price = $('#product-detail-form meta[itemprop="price"]').attr('content')
        var availability = $('#product-detail-form link[itemprop="availability"]').attr('href')
        var category = $('.breadcrumbs #navigation-2 span[itemprop="name"]').text().trim()
        var AggregateRatingbestRating = $('#product-detail-form span[itemprop="AggregateRating"] meta[itemprop="bestRating"]').attr('content')
        var AggregateRatingbestworstRating = $('#product-detail-form span[itemprop="AggregateRating"] meta[itemprop="worstRating"]').attr('content')
        var AggregateRatingbestRatingratingValue = $('#product-detail-form span[itemprop="AggregateRating"] meta[itemprop="ratingValue"]').attr('content')
        var AggregateRatingbestRatingratingCount = $('#product-detail-form span[itemprop="AggregateRating"] meta[itemprop="ratingCount"]').attr('content')
        function getPositiveNotes() {
            const list = [];
            $('.p-short-description[data-testid="productCardShortDescr"] ul li').each(function(index) {
                let text = $(this).text().trim();
                if (text.length > 0) {
                    list.push({
                        "@type": "ListItem",
                        "position": index + 1,
                        "name": text
                    });
                }
            });
            return {
                "positiveNotes": {
                    "@type": "ItemList",
                    "itemListElement": list
                }
            };
        }
        var jsonLdData = {
            "@context": "https://schema.org",
            "@type": "Product",
            "name": name,
            "url": url,
            "image": [
                image
            ],
            "description": description,
            "sku": sku,
            "brand": {
                "@type": "Brand",
                "name": brand
            },
            "category": category,
           // "material": "Plastové korálky; odolné rukojeti",
            "itemCondition": "https://schema.org/NewCondition",
            ...getPositiveNotes(),
            "offers": {
                "@type": "Offer",
                "url": url,
                "priceCurrency": priceCurrency,
                "price": price,
                "availability": availability,
                "seller": {
                    "@type": "Organization",
                    "name": brand
                }
            },
            "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": AggregateRatingbestRatingratingValue,
                "bestRating": AggregateRatingbestRating,
                "worstRating": AggregateRatingbestworstRating,
                "ratingCount": AggregateRatingbestRatingratingCount,
                "reviewCount": AggregateRatingbestRatingratingCount
            }
        };

        // vytvoření <script> tagu
        var $script = $('<script>', {
            type: 'application/ld+json',
            text: JSON.stringify(jsonLdData)
        });

        // vložení do <head>
        $('head').append($script);
    });
}

